var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrop = function SvgCrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B1B1B3",
    d: "M14.375 18.958v-3.333H5.881q-.63 0-1.069-.437a1.45 1.45 0 0 1-.437-1.07V5.626H1.042v-1.25h3.333V1.042h1.25v13.077q0 .096.08.176t.176.08h13.077v1.25h-3.333v3.333zm0-5.833V5.882a.24.24 0 0 0-.08-.177.25.25 0 0 0-.177-.08H6.875v-1.25h7.243q.633 0 1.07.438.437.437.437 1.069v7.243z"
  })));
};
export default SvgCrop;